export enum applicationCreateTypes {
  FETCH_APPLICATION_CREATE_REQUEST = "FETCH_APPLICATION_CREATE_REQUEST",
  FETCH_APPLICATION_CREATE_SUCCESS = "FETCH_APPLICATION_CREATE_SUCCESS",
  FETCH_APPLICATION_CREATE_FAILURE = "FETCH_APPLICATION_CREATE_FAILURE",
}